import { connect } from 'react-redux';
import { injectIntl, intlShape, addLocaleData } from 'react-intl';
import autobind from 'core-decorators/lib/autobind';
import CSSModules from 'react-css-modules';

import getDisplayName from './get-component-display-name';
import { sendBiEvent, sendBiError } from 'shared/redux/client/actions/bi';


// window.wix.reactIntlLocaleData is loaded using expose-loader. see webpack config
addLocaleData(window.wix.reactIntlLocaleData);


export function VODCSSModules(styles) {
  if (!styles) {
    return _.identity;
  }

  return CSSModules(styles, {
    allowMultiple: true,
    errorWhenNotFound: false,
  });
}

@connect(null, { sendBiEvent, sendBiError })
export function VODBiEvents() {
  return function (WrappedComponent) {
    class VODBiEventsWrapper extends React.Component {
      static displayName = `VODBiEventsWrapper(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        sendBiEvent: React.PropTypes.func,
        sendBiError: React.PropTypes.func,
      };


      static contextTypes = {
        defaultBiParams: React.PropTypes.object,
      };

      @autobind
      biEvent(name, params) {
        return this.props.sendBiEvent(name, { ...this.context.defaultBiParams, ...params });
      }

      @autobind
      biError(name, params) {
        return this.props.sendBiError(name, { ...this.context.defaultBiParams, ...params });
      }

      render() {
        const props = _({})
          .assign(this.props, {
            biEvent: this.biEvent,
            biError: this.biError,
          })
          .omit('sendBiEvent', 'sendBiError')
          .value();

        return (
          <WrappedComponent {...props} />
        );
      }
    }

    VODBiEventsWrapper.WixWrappedComponent = WrappedComponent;

    return VODBiEventsWrapper;
  };
}


/*
 * Injects these behaviours: CSSModules, biEvent|biError, Intl
 */
@connect(null, { sendBiEvent, sendBiError })
export function WixConnect(styles) {
  return function (WrappedComponent) {

    WrappedComponent = VODCSSModules(styles)(WrappedComponent);

    @injectIntl
    class ConnectWixStuff extends React.Component {

      static displayName = `ConnectWixStuff(${getDisplayName(WrappedComponent)})`;
      static propTypes = {
        settings: React.PropTypes.object,
        intl: intlShape,
        sendBiEvent: React.PropTypes.func,
        sendBiError: React.PropTypes.func,
      };

      static contextTypes = {
        settings: React.PropTypes.object,
        store: React.PropTypes.object,
        defaultBiParams: React.PropTypes.object,
      };

      @autobind
      biEvent(name, params) {
        return this.props.sendBiEvent(name, { ...this.context.defaultBiParams, ...params });
      }

      @autobind
      biError(name, params) {
        return this.props.sendBiError(name, { ...this.context.defaultBiParams, ...params });
      }

      render() {
        const { settings } = this.context;
        const { intl, settings: propsSettings } = this.props;

        const props = _({})
          .assign(this.props, {
            settings: propsSettings || settings,
            intl,
            biEvent: this.biEvent,
            biError: this.biError,
          })
          .omit('sendBiEvent', 'sendBiError')
          .value();

        return <WrappedComponent {...props} />;
      }
    }

    ConnectWixStuff.WixWrappedComponent = WrappedComponent;

    return ConnectWixStuff;
  };
}



// WEBPACK FOOTER //
// ./src/shared/utils/wix-connect.js